// 1: 'device_charging_pile',
//         2: 'device_ac_pile',
//         3: 'device_energy_pile',
//         4: 'device_power',
//         5: 'device_home_energy',
//         6: 'device_v2g',
export default [
  {
    value: 1,
    icon: 'device_charging_pile',
  },
  {
    value: 2,
    icon: 'device_ac_pile',
  },
  {
    value: 3,
    icon: 'device_energy_pile',
  },
  {
    value: 4,
    icon: 'device_power',
  },
  {
    value: 5,
    icon: 'device_home_energy',
  },
  {
    value: 6,
    icon: 'device_v2g',
  },
];
